import {JsonAdapter} from "../helpers/JsonAdapter";
import dayjs from 'dayjs';

export class WorkExperience {
  position: string = "";
  description: string = "";
  organisation_name: string = "";
  start_year: string = "";
  end_year: string = "";

  static create(object:any): WorkExperience {
    const item = JsonAdapter.fill(new WorkExperience(), object);

    if(object.start_year) {
      item.start_year = dayjs(item.start_year).year().toString();
    }

    if(object.end_year) {
      item.end_year = dayjs(item.end_year).year().toString();
    }

    return item;
  }

  static createMultiple(objects: WorkExperience[]): WorkExperience[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(WorkExperience.create(objects[i]));
    }
    return items;
  }

  get period() {
    return this.start_year + ' - ' + (this.end_year ? this.end_year : 'Present');
  }
}
